<template>
  <f7-page no-swipeback>
    <f7-navbar title="確認訂單 Order Confirm" back-link="返回 Back"></f7-navbar>

    <f7-list v-if="data && data.length > 0" media-list>
      <f7-list-input
        label="訂單日期 ORDER DATE"
        type="date"
        placeholder="Please choose..."
        class="datepicker"
        :value="order_at"
        @input="updateDate"
      >
        <f7-icon icon="demo-list-icon" slot="media"></f7-icon>
      </f7-list-input>

      <f7-list-input
        label="備註 REMARKS"
        class="datepicker"
        placeholder="請輸入備註（如有）"
        :value="remark"
        @input="updateRemark"
      >
        <f7-icon icon="demo-list-icon" slot="media"></f7-icon>
      </f7-list-input>

      <f7-list-group :key="category_index" v-for="(category, category_index) in data">
        <f7-list-item :title="category.category_name" group-title></f7-list-item>

        <f7-list-item
          v-for="product in category.products"
          :key="product.id"
          :title="product.name"
          class="text-orange"
        >
          <list-product-item
            :product="product"
            :readonly="true"
          />
        </f7-list-item>
      </f7-list-group>
    </f7-list>

    <f7-toolbar position="bottom" v-if="this.data && this.data.length > 0">
      <div class="bottom-overview" style="font-size: 15px">
        {{ products_total }} 項 Items，{{ quantity_total }} 件 Quantity
        <br>合計 Total ${{ subtotal }}
      </div>
      <f7-link @click="order">下單 Place Order</f7-link>
    </f7-toolbar>
  </f7-page>
</template>

<script>
import { format } from 'date-fns'
import axios from 'axios'

const { formatToTimeZone } = require('date-fns-timezone')

import ListProductItem from './ListProductItem.vue'

export default {
  components: {
    ListProductItem,
  },

  props: ['data'],

  data: () => ({
    order_at: format(new Date(), 'yyyy-MM-dd'),
    remark: '',
  }),

  mounted() {
    if (typeof this.data === 'undefined') {
      this.$f7router.navigate('/', {reloadAll: true})
      return
    }
  },

  computed: {
    products_total() {
      return this.data.reduce((accumulator, category) => {
        return category.products.reduce((accumulator_products, product) => {
          return accumulator_products + ((product.quantity > 0) ? 1 : 0)
        }, accumulator)
      }, 0)
    },
    quantity_total() {
      let quantity = this.data.reduce((accumulator, category) => {
        return category.products.reduce((accumulator_products, product) => {
          return accumulator_products + product.quantity
        }, accumulator)
      }, 0)

      return quantity
    },
    subtotal() {
      const subtotal = this.data.reduce((accumulator, category) => {
        return category.products.reduce((accumulator_products, product) => {
          return accumulator_products + (product.quantity * product.price)
        }, accumulator)
      }, 0)

      return Math.round(subtotal * 10) / 10
    },
  },

  methods: {
    order() {
      let flattened_products = this.data
        .map(category => {
          return category.products.reduce((res, product) => {
            res.push({
              id: product.id,
              quantity: product.quantity,
            })

            product.inventories
              .filter(inventory => inventory.order_quantity > 0)
              .forEach((inventory) => {
                res.push({
                  id: product.id,
                  quantity: inventory.order_quantity,
                  expired_date: inventory.expired_date,
                })
              })

            return res
          }, [])
        })
        .flat()
        .filter(product => product.quantity > 0)

      let order_data = {
        order_at: formatToTimeZone(this.order_at, 'YYYY-MM-DD HH:mm', { timeZone: 'UTC' }),
        remark: (this.remark === '') ? '-' : this.remark,
        products: flattened_products,
      }

      this.$f7.dialog.preloader('提交中 Submitting');

      axios.post('/api/orders', order_data)
        .then(() => {
          this.$f7.dialog.close()

          this.$f7.dialog.alert('已提交 Submitted', undefined, () => {
            this.$f7router.navigate('/', {reloadAll: true})
          })
        })
        .catch(() => {
          this.$f7.dialog.alert('發生錯誤，請重試。An Error Occured, Please Try Again.')
        })
    },
    updateDate(e) {
      this.order_at = e.target.value
    },
    updateRemark(e) {
      this.remark = e.target.value
    }
  }
}
</script>
